import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import moment from "moment";
import Request from "request";
import Loading from "../../Loading";
import {Breadcrumb, Button, Col, FormControl, Row, Table} from "react-bootstrap";
import {Event} from "../../Comet";
import { LinkContainer } from "react-router-bootstrap";
import locale from "../../../locale";

function PresenceCheckList({presenceChecks}) {
    if (0 === presenceChecks.length) {
        return (
            <div>Вы ещё не запустили проверку</div>
        );
    }

    const PresenceRow = ({presence}) => {
        const isActive = presence.timeStop > moment().unix();

        return (
            <tr style={{backgroundColor: isActive ? '#beb' : ''}}>
                <td>{presence.id}</td>
                <td>{moment.unix(presence.timeStart).format('YYYY-MM-DD HH:mm:ss')}</td>
                <td>{moment.unix(presence.timeStop).format('YYYY-MM-DD HH:mm:ss')}</td>
                <td>{presence.timeout}</td>
            </tr>
        );
    }

    return (
        <Table>
            <colgroup>
                <col style={{width: 40}} />
                <col />
                <col />
                <col style={{width: 80}} />
            </colgroup>
            <thead>
            <tr>
                <th>ID</th>
                <th>Старт</th>
                <th>Стоп</th>
                <th>Таймер</th>
            </tr>
            </thead>
            <tbody>
            {presenceChecks.map(presence => <PresenceRow key={presence.id} presence={presence} />)}
            </tbody>
        </Table>
    );
}

function PresenceCheckStart({onStart}) {
    const [timeout, setTimeout] = useState(60);

    const handleStart = () => onStart({timeout});

    return (
        <section>
            <Row>
                <Col xs={12}>
                    Таймер{' '}
                    <FormControl
                        type="text"
                        value={timeout}
                        onChange={(e) => setTimeout(e.target.value)}
                        style={{width: 60, display: 'inline-block', verticalAlign: 'top'}}
                    />
                    {' '}
                    <Button onClick={handleStart}>Запустить проверку</Button>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    После старта контроля, участник получит сообщение с просьбой подтвердить своё присутствие.
                </Col>
            </Row>
        </section>
    );
}

function PresenceCheckStop({onStop}) {
    const handleStop = () => onStop();

    return (
        <Row>
            <Col xs={12}>
                <Button onClick={handleStop}>Остановить проверку</Button>
            </Col>
        </Row>
    );
}

function PresenceCheckPage({event}) {
    const [presenceChecks, setPresenceChecks] = useState(null);
    const [lastUpdate, setLastUpdate] = useState(null);

    const onPresenceUpdate = (presence) => {
        const index = presenceChecks.findIndex(p => p.id === presence.id);
        if (-1 === index) {
            setPresenceChecks([...presenceChecks, presence]);
        } else {
            const presences = [...presenceChecks];
            presences[index] = presence;
            setPresenceChecks(presences);
        }
    };

    const startCheck = ({timeout=60}) => Request.post(`/api/cp/event/${event.eventPassword}/presence`, {timeout})
        .then(onPresenceUpdate)
    ;
    const stopCheck = () => Request.delete(`/api/cp/event/${event.eventPassword}/presence`)
        .then(onPresenceUpdate)
    ;

    useEffect(() => {
        Request.get(`/api/cp/event/${event.eventPassword}/presence`)
            .then(setPresenceChecks)
        ;
    }, []);

    if (null === presenceChecks) {
        return <Loading />;
    }

    const activeCheck = presenceChecks.find(c => null === c.timeStop || c.timeStop > moment().unix());

    if (activeCheck) {
        setTimeout(() => {
            setLastUpdate(moment().unix());
        }, (activeCheck.timeStop - moment().unix() + 1) * 1000);
    }

    return (
        <section>
            <Event event="start:presence" handler={onPresenceUpdate} />
            <Event event="stop:presence" handler={onPresenceUpdate} />
            <Breadcrumb>
                <LinkContainer to={`/event/${event.eventPassword}`}>
                    <Breadcrumb.Item>{locale('mainMenu.interactive')}</Breadcrumb.Item>
                </LinkContainer>
                <Breadcrumb.Item active>{locale('mainMenu.presenceCheck')}</Breadcrumb.Item>
            </Breadcrumb>
            <PresenceCheckList presenceChecks={presenceChecks} />
            {activeCheck
                ? <PresenceCheckStop onStop={stopCheck} />
                : <PresenceCheckStart onStart={startCheck} />
            }
        </section>
    );
}

const mapStateToProps = (store) => ({
    event: store.currentEvent
});

export default connect(mapStateToProps)(PresenceCheckPage);
